import React from 'react';
import { AlertCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-20 md:py-24 bg-white relative" data-id="element-213">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-214">
        <div className="flex flex-col items-center text-center mb-12" data-id="element-215">
          <FadeIn data-id="element-216">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-red-50 text-red-500 mb-6" data-id="element-217">
              <AlertCircle size={24} data-id="element-218" />
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-219">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6" data-id="element-220">
              El bullying no es "cosa de niños". Es un robo de identidad en
              tiempo real.
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-navy/80 leading-relaxed" data-id="element-221">
          <FadeIn delay={0.2} data-id="element-222">
            <p data-id="element-223">
              Cuando un niño de 8-12 años es acosado, empieza a creer que los
              insultos son ciertos. Su cerebro deja de aprender para entrar en
              modo "supervivencia".
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-224">
            <div className="p-6 md:p-8 rounded-2xl bg-red-50/50 border border-red-100" data-id="element-225">
              <p className="font-medium text-navy" data-id="element-226">
                El problema es que la mayoría de los consejos tradicionales son
                gasolina para el acosador.
              </p>
              <p className="mt-4" data-id="element-227">
                "Ignorarlo" solo hace que el agresor suba el volumen para
                obtener la reacción que busca. "Razonar" le da importancia al
                insulto. Tu hijo no necesita "aguantar",{' '}
                <strong className="text-red-600 font-semibold" data-id="element-228">
                  necesita un sistema de neutralización.
                </strong>
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}